const ORDER_BY = {
  ASC: 'asc',
  DESC: 'desc'
};

export { ORDER_BY };
